import React, { FC, useState, useRef, SyntheticEvent } from 'react';

export type MessageVariants =
  | 'primary-info'
  | 'secondary-info'
  | 'primary-complete'
  | 'secondary-complete'
  | 'primary-warn'
  | 'secondary-warn'
  | 'primary-error'
  | 'secondary-error'
  | 'alert-error';

export type MessageProps = {
  children?: React.ReactNode;
  variant: MessageVariants;
  closeAriaLabel?: string;
  openAriaLabel?: string;
  closeId?: string;
  openId?: string;
  className?: string;
};
export const Message: FC<MessageProps> = ({
  variant,
  closeAriaLabel,
  openAriaLabel,
  closeId,
  openId,
  children,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const buttonRef = useRef<HTMLButtonElement>();

  const onOpenClose = (e: SyntheticEvent) => {
    e.preventDefault();
    setIsOpen(!isOpen);
    setTimeout(() => buttonRef.current && buttonRef.current.focus(), 0);
  };
  const role = variant && (variant.includes('complete') || variant.includes('info')) ? 'status' : 'alert';
  return (
    <div aria-atomic="true" aria-live="polite" role={role} className={`${className}`}>
      {isOpen ? (
        <div className={`alert-message ${variant}`}>
          <div className="d-flex alert-icon" aria-hidden="true">
            <span />
          </div>
          <div className="alert-text" data-testid="message">
            {children}
          </div>
          {variant.includes('primary') && (
            <div className="alert-close" aria-live="off">
              <button
                id={closeId}
                ref={buttonRef}
                aria-label={closeAriaLabel}
                data-testid={closeId}
                type="button"
                onClick={onOpenClose}
              />
            </div>
          )}
        </div>
      ) : (
        <div>
          <button
            id={openId}
            ref={buttonRef}
            data-testid={openId}
            className="alert-message-close alt-primary-semi-dark-bg"
            type="button"
            aria-label={openAriaLabel}
            onClick={onOpenClose}>
            <span aria-hidden="true" className="notification-bell" />
            <span aria-hidden="true" className="notification-alert" />
          </button>
        </div>
      )}
    </div>
  );
};
Message.displayName = 'Message';
export default Message;
